export enum OrderStatus {
    Pending = 1,
    Approved = 2,
    Encoded = 3,
    EncodingFailed = 4,
    DeliveryApproved = 5,
    DeliveryCompleted = 6,
    DeliveryFailed = 7,
    Rejected = 8,
    DeliveryError = 9,
    Cancelled = 10,
    Overridden = 11
}

export const mapToOrderStatus = (status: number): OrderStatus => {
    if (status in OrderStatus) {
        return status;
    }

    throw new Error("Incorrect Order Status.");
};
